import { render, staticRenderFns } from "./GameRecord.vue?vue&type=template&id=fa3eefe0&scoped=true"
import script from "./GameRecord.vue?vue&type=script&lang=js"
export * from "./GameRecord.vue?vue&type=script&lang=js"
import style0 from "./GameRecord.vue?vue&type=style&index=0&id=fa3eefe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3eefe0",
  null
  
)

export default component.exports